<script>

export default {
  name: "SelectBox",
  emits: ['update:modelValue', 'update:modelObject', 'change'],
  props: {
    options: {
      default: []
    },
    onSearchChange: {
      default: () => {
      },
      type: Function
    },
    displayField: {
      default: 'name'
    },
    valueField: {
      default: 'id'
    },
    multiple: {
      default: false
    },
    loading: {
      default: false
    },
    modelValue: {default: ''},

    required: Boolean
  },
  data() {
    return {
      options_data: [],
      options_data_raw: [],
      selected_data: [],
    }
  },
  mounted() {
    this.options_data_raw = this.options;
  },
  watch: {
    options: {
      handler(newValue) {
        this.options_data_raw = newValue;
      },
    },
    options_data_raw: {
      handler(newValue) {
        try {
          if (newValue) {
            this.options_data = newValue.map((item) => {
              if (!item) return;
              let _item = {value: item[this.valueField]}
              if (typeof this.displayField === 'function') {
                _item.label = this.displayField(item)
              } else {
                _item.label = item[this.displayField]
              }
              return _item;
            });
          }
        } catch (e) {
          console.error('Lỗi build option', newValue);
        }

      }
    },
    modelValue: {
      handler(newValue) {
        this.selected_data = newValue;
      },
      immediate: true
    },
    selected_data: {
      handler(newVal) {
        this.$emit('update:modelValue', newVal);
        let objects = null;
        if (newVal) {
          if (this.options_data_raw.length > 0) {
            if (this.multiple) {
              objects = this.options_data_raw.filter((item) => {
                if (!item) {
                  return false
                }
                return item[this.valueField] === newVal
              })
            } else {
              objects = this.options_data_raw.find((item) => {
                if (!item) {
                  return false
                }
                return item[this.valueField] === newVal
              })
            }
          }
        }
        this.$emit('update:modelObject', objects);
        this.$emit('change', objects)
      }
    },
  },
}
</script>

<template>
    <v-select class="form-control"
              v-model="selected_data"
              :options="options_data"
              :searchable="true"
              :mode="multiple?'multiple':'single'"
              ref="_select_box_multiple"
              :hideSelected="false"
              :loading="loading"
              :required="required"
              :closeOnSelect="!this.multiple"
              :noOptionsText="this.loading?'Đang lấy dữ liệu':'Không có dữ liệu'"
              @search-change="onSearchChange"
    >
      <template v-slot:multiplelabel="{ values }">
        <div class="multiselect-multiple-label">
          -- Đã chọn {{ values.length }}.
        </div>
      </template>
    </v-select>
</template>

<style scoped>

</style>
